import src from "IMAGE";
export default { src, width: 142, height: 124, blurWidth: 0, blurHeight: 0};
